import { DateRange } from 'bold-ui'
import { isSameDay } from 'date-fns'
import { InstantRange } from 'util/date/dateRange'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

export function toPeriodDate(value: Date | number | undefined): Date | undefined {
  if (!value) {
    return undefined
  }

  return typeof value === 'number' ? new Date(value) : value
}

export function formatPeriodDate(date: Date, today: Date): string {
  return isSameDay(date, today) ? 'hoje' : dateAsDdMmYyyy(date)
}

export function getPeriodFilterText(period: DateRange | InstantRange, today: Date): string | undefined {
  const startDate = toPeriodDate(period?.startDate)
  const endDate = toPeriodDate(period?.endDate)

  const formattedStartDate = startDate ? formatPeriodDate(startDate, today) : undefined
  const formattedEndDate = endDate ? formatPeriodDate(endDate, today) : undefined

  if (startDate && endDate) {
    const isBothToday = isSameDay(startDate, endDate) && isSameDay(startDate, today)
    return isBothToday ? 'Hoje' : `${formattedStartDate} até ${formattedEndDate}`.capitalize()
  }

  if (startDate) {
    return `A partir de ${formattedStartDate}`
  }

  if (endDate) {
    return `Até ${formattedEndDate}`
  }

  return undefined
}
